import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import { Mic, AttachFile } from '@mui/icons-material';

interface VoiceMessageIconProps {
  fontSize?: 'small' | 'medium' | 'large';
  sx?: SxProps<Theme>;
}

/**
 * Icon combining microphone and attachment to represent voice message (audio file)
 */
export const VoiceMessageIcon: React.FC<VoiceMessageIconProps> = ({ fontSize = 'small', sx }) => {
  return (
    <Box
      sx={{
        position: 'relative',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: fontSize === 'small' ? 20 : fontSize === 'medium' ? 24 : 28,
        height: fontSize === 'small' ? 20 : fontSize === 'medium' ? 24 : 28,
        ...sx
      }}
    >
      <Mic fontSize={fontSize} />
      <AttachFile
        fontSize="inherit"
        sx={{
          position: 'absolute',
          right: -4,
          bottom: -4,
          fontSize: fontSize === 'small' ? '0.6em' : '0.65em',
          backgroundColor: 'background.paper',
          borderRadius: '50%',
          padding: '1px'
        }}
      />
    </Box>
  );
};

export default VoiceMessageIcon;
